import { reactive } from 'vue'

let seed = 0

export const toastState = reactive({
  list: []
})

export function notify(message, type = 'info', duration = 3000) {
  const item = { id: ++seed, message, type }
  toastState.list.push(item)
  setTimeout(() => removeToast(item.id), duration)
}

function removeToast(id) {
  const index = toastState.list.findIndex((item) => item.id === id)
  if (index > -1) {
    toastState.list.splice(index, 1)
  }
}

notify.success = (message, duration) => notify(message, 'success', duration)
notify.error = (message, duration) => notify(message, 'error', duration)
notify.info = (message, duration) => notify(message, 'info', duration)
